import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const phonesService = new CachedService(entities.Orderadmin_Clients_Entity_Phone, '/clients/phone', HALApiService, createItemsData)
